<template>
  <div>
    <template>
      <div class="container-title">
        <h1>Personal Info</h1>
      </div>
      <b-loading :is-full-page="false" :active="isLoading" :can-cancel="false"></b-loading>
      <div v-if="!isLoading" class="container-content">
        <Card title="Profile" :editSection="editSection">
            <CardProfile title="Profile" @edit-card="onEditCard"
                         :editSection="editSection"></CardProfile>
        </Card>
        <Card title="Password" :editSection="editSection">
            <CardPassword title="Password"
                          @edit-card="onEditCard"
                          :editSection="editSection"></CardPassword>
        </Card>
        <Card
            v-if="isContractorUser || isSwitched || partnerId"
            title="Company Profile"
            :editSection="editSection"
        >
          <CardCompanyProfile title="Company Profile"
                        @edit-card="onEditCard"
                        :editSection="editSection"></CardCompanyProfile>
        </Card>
        <Card v-if="contractorId" title="Email Notifications" :editSection="editSection">
          <EmailNotifications title="Email Notifications"
                              @edit-card="onEditCard"
                              :editSection="editSection"></EmailNotifications>
        </Card>

        <Card
            v-if="contractorId && (isContractorUser || isSwitched || isTeamUsersManagingAllowed)"
            v-show="teamManagementIsActive"
            :is-double-card="true"
            :title="teamManagementTitle"
            :editSection="editSection"
        >
          <CardTeamManagement
              :title.sync="teamManagementTitle"
              :is-active.sync="teamManagementIsActive"
              @edit-card="onEditCard"
              :editSection="editSection"
          />
        </Card>
      </div>
    </template>
  </div>
</template>

<script>
import Card from '@/components/Main/PersonalInfo/Card.vue';
import CardProfile from '@/components/Main/PersonalInfo/Card/Profile.vue';
import CardPassword from '@/components/Main/PersonalInfo/Card/Password.vue';
import CardCompanyProfile from '@/components/Main/PersonalInfo/Card/CompanyProfile.vue';
import EmailNotifications from '@/components/Main/PersonalInfo/Card/EmailNotifications.vue';
import CardTeamManagement from '@/components/Main/PersonalInfo/Card/TeamManagement/Card.vue';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'Container',
  components: {
    Card,
    CardProfile,
    CardPassword,
    CardCompanyProfile,
    EmailNotifications,
    CardTeamManagement,
  },
  data: () => {
    const endDate = new Date();
    const startDate = new Date();
    startDate.setDate(endDate.getDate() - 729);

    return {
      editSection: '',
      isLoading: false,
      teamManagementTitle: '',
      teamManagementIsActive: false,
    };
  },
  computed: {
    ...mapState('partner', {
      partnerId: (state) => state.id,
    }),
    ...mapState('contractor', {
      contractorId: (state) => state.id,
    }),
    ...mapState('user', {
      isContractorUser: (state) => state.isContractorUser,
      isTeamUsersManagingAllowed: (state) => state.contractorTeamData?.isTeamUsersManagingAllowed,
    }),
    ...mapGetters(['isSwitched']),
  },
  deactivated() {
    this.isLoading = false;
    this.editSection = '';
  },
  methods: {
    onEditCard(value) {
      this.editSection = value;
    },
  },
};
</script>

<style lang="stylus" scoped>
.container-title {
  margin-bottom 40px
  & h1 {
    font-size: 34px;
    font-weight: 700;
    color: #4C7B93;
    @media (max-width 1170px) {
      font-size: 26px;
    }
    @media (max-width 360px) {
      line-height: 1.875rem;
    }
  }
}
.container-content {
  display flex
  gap 40px
  flex-wrap wrap
  >>>.loading-overlay {
    z-index: 10;
  }
}

.personal-card-container--double
  width calc(400px * 2 + 40px)
  @media (max-width 1142px)
    width 100%

</style>
